import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Fab, Tooltip, Grow } from '@mui/material';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

const SaveFab = function SaveFab({
  handleSave = () => {},
  enableSaving = false,
}) {
  const intl = useIntl();

  return (
    <Grow in={enableSaving}>
      <Tooltip title={intl.messages.SAVE} placement="bottom">
        <Fab
          id="save-fab"
          aria-label="save"
          color="primary"
          onClick={handleSave}
          sx={{
            position: 'absolute',
            bottom: '1%',
            right: '21%',
          }}
        >
          <SaveRoundedIcon />
        </Fab>
      </Tooltip>
    </Grow>
  );
};

SaveFab.propTypes = {
  handleSave: PropTypes.func,
  enableSaving: PropTypes.bool,
};
export default SaveFab;
